import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from "./Avatar.vue";
import { S3_BUCKET_URL } from "../../utils/constants";
import { backgroundColorFromIdentity } from "../../utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfileAvatar",
  components: {
    Avatar
  },
  props: {
    username: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    givenName: {
      type: String,
      default: ""
    },
    familyName: {
      type: String,
      default: ""
    },
    profilePhoto: {
      type: [Boolean, String],
      default: false
    },
    photoVersion: {
      type: [String, Number],
      default: ""
    },
    avatarSize: {
      type: [String, Number],
      default: ""
    },
    avatarOptions: {
      type: Object,
      default: () => ({})
    },
    avatarInitials: {
      type: String,
      default: ""
    },
    coApplicant: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    inline() {
      var _this$avatarOptions$i;
      return (_this$avatarOptions$i = this.avatarOptions.inline) != null ? _this$avatarOptions$i : true;
    },
    stylesOverride() {
      return {
        width: undefined,
        height: undefined,
        backgroundSize: "100% 100%"
      };
    },
    imgSrc() {
      if (typeof this.profilePhoto === "string") return this.profilePhoto;
      return this.profilePhoto ? `${S3_BUCKET_URL}/profile-photos/${this.username}?v=${this.photoVersion}` : undefined;
    },
    familyNameInitial() {
      var _this$coApplicant, _this$coApplicant$fam;
      const familyName = this.familyName || "";
      return ((_this$coApplicant = this.coApplicant) == null ? void 0 : (_this$coApplicant$fam = _this$coApplicant.familyName) == null ? void 0 : _trimInstanceProperty(_this$coApplicant$fam).call(_this$coApplicant$fam).charAt(0)) || _trimInstanceProperty(familyName).call(familyName).charAt(0);
    },
    givenNameInitial() {
      var _this$coApplicant2, _this$coApplicant2$gi;
      const givenName = this.givenName || "";
      return ((_this$coApplicant2 = this.coApplicant) == null ? void 0 : (_this$coApplicant2$gi = _this$coApplicant2.givenName) == null ? void 0 : _trimInstanceProperty(_this$coApplicant2$gi).call(_this$coApplicant2$gi).charAt(0)) || _trimInstanceProperty(givenName).call(givenName).charAt(0);
    },
    initials() {
      const initials = `${this.givenNameInitial}${this.familyNameInitial}`.toUpperCase();
      return this.avatarInitials || initials || "AA";
    },
    fontColor() {
      return "#FFFFFF";
    },
    backgroundColor() {
      return backgroundColorFromIdentity(this.username || this.id);
    }
  }
});